// Heures affichées : jamais de décalage fixe, toujours Intl (le changement d'heure tombe le 25/10).

const PARIS = "Europe/Paris";

function parts(iso: string, timeZone?: string) {
  const fmt = new Intl.DateTimeFormat("fr-FR", {
    timeZone,
    weekday: "long",
    day: "2-digit",
    month: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hourCycle: "h23",
  });
  const out: Record<string, string> = {};
  for (const p of fmt.formatToParts(new Date(iso))) out[p.type] = p.value;
  return out;
}

function hm(p: Record<string, string>): string {
  // « 24 » ne sort jamais en h23, mais on normalise par prudence.
  return `${Number(p.hour) % 24} h ${p.minute}`;
}

/** Jour et heure de Paris : `{ day: "vendredi 23/10", time: "10 h 00" }`. */
export function formatParis(iso: string): { day: string; time: string } {
  const p = parts(iso, PARIS);
  return { day: `${p.weekday.toLowerCase()} ${p.day}/${p.month}`, time: hm(p) };
}

/** Heure de Paris (0 à 23) d'un instant ISO. */
export function parisHour(iso: string): number {
  return Number(parts(iso, PARIS).hour) % 24;
}

/** Heure dans le fuseau du navigateur (ou du runtime) : `"9 h 00"`. */
export function formatLocalTime(iso: string): string {
  return hm(parts(iso));
}
